import {Component} from '@angular/core';
import {ComponentRef} from '@angular/core';
import {HostBinding} from '@angular/core';
import {OnInit} from '@angular/core';
import {ViewChild} from '@angular/core';

import {BasePortalHost} from 'app/ui/core/portal';
import {ComponentPortal} from 'app/ui/core/portal';
import {DialogConfig} from './dialog-config';
import {UIPortalHostDirective} from 'app/ui/core/portal-directives';
import {TemplatePortal} from 'app/ui/core/portal';

@Component({
    selector: 'ui-dialog',
    template: '<ng-template cdkPortalHost></ng-template>',
    styleUrls: ['dialog.component.scss']
})
export class UIDialogComponent extends BasePortalHost implements OnInit {

    @ViewChild(UIPortalHostDirective)
    private _portalHost: UIPortalHostDirective;

    dialogConfig: DialogConfig;

    @HostBinding('class.no-padding')
    noPadding: boolean = false;

    constructor() {
        super();
    }

    ngOnInit() {
        this.noPadding = this.dialogConfig.noPadding || false;
    }

    attachComponentPortal<T>(portal: ComponentPortal<T>): ComponentRef<T> {
        if (this._portalHost.hasAttached()) {
            throw new Error('Attempting to attach dialog content after content is already attached');
        }
        return this._portalHost.attachComponentPortal(portal);
    }

    attachTemplatePortal(portal: TemplatePortal): void {
        if (this._portalHost.hasAttached()) {
            throw new Error('Attempting to attach dialog content after content is already attached');
        }
        this._portalHost.attachTemplatePortal(portal);
    }
}
